module.exports = __webpack_public_path__ + "img/star_gray.3f5bd7d1.png";